import { Component, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';

@Component({
  selector: 'share-option-form',
  templateUrl: './share-option.component.html',
  styleUrls: ['./share-option.component.scss'],
  standalone: false,
})
export class ShareOptionComponent implements OnInit {
  public static readonly id = 'share=options-modal';
  public toEmailIds: string = '';
  public toPhoneNumbers: string = '';
  public selectedCountryCode: string = '+91';

  public emailError: string = '';
  public phoneError: string = '';

  constructor(private modalController: ModalController) {}

  ngOnInit(): void {
    
  }
  
  public onSendClick() {
    this.emailError = '';
    this.phoneError = '';

    const emailIds = this.toEmailIds
      .split(',')
      .map((e) => e.trim())
      .filter((e) => !!e);
    const phoneNumbers = this.toPhoneNumbers
      .split(',')
      .map((p) => p.trim())
      .filter((p) => !!p);

    const invalidEmails = emailIds.filter((email) => !this.isValidEmail(email));
    const invalidPhones = phoneNumbers.filter(
      (phone) => !this.isValidPhone(phone)
    );

    if (invalidEmails.length > 0) {
      this.emailError = 'Invalid email(s): ' + invalidEmails.join(', ');
    }

    if (invalidPhones.length > 0) {
      this.phoneError = 'Invalid phone(s): ' + invalidPhones.join(', ');
    }

    if (this.emailError || this.phoneError) {
      return; // Don't proceed if there's any error
    }

    const formattedPhones = phoneNumbers.map(
      (phone) => this.selectedCountryCode + phone
    );

    this.modalController.dismiss(
      { toEmailIds: emailIds, toPhoneNumbers: formattedPhones },
      '',
      ShareOptionComponent.id
    );
  }

  public onCancelClick() {
    this.modalController.dismiss({}, '', ShareOptionComponent.id);
  }

  private isValidEmail(email: string): boolean {
    const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return regex.test(email);
  }

  private isValidPhone(phone: string): boolean {
    const regex = /^[0-9]{6,15}$/;
    return regex.test(phone);
  }
}
